import { List, Map } from 'immutable'
import { IMenuItem } from 'hooks/useMenu'

const frItems: IMenuItem[] = [
  {
    title: 'Logos',
    items: [],
    link: '/fr/media/mediatheque/freebox',
    description: 'Logos du Groupe et de ses filiales',
    imageUrl: '/assets/images/photo-library/iliad.png'
  },
  {
    title: 'Freebox',
    items: [],
    link: '/fr/media/mediatheque/freebox',
    description: 'Photos des différentes box et des interfaces TV correspondantes',
    imageUrl: '/assets/images/photo-library/iliad.png'
  },
  {
    title: 'Boutiques Free',
    items: [],
    link: '/fr/media/mediatheque/boutiques',
    description: 'Photos des boutiques Free',
    imageUrl: '/assets/images/photo-library/iliad.png'
  }
]

const enItems: IMenuItem[] = [
  {
    title: 'Logos',
    items: [],
    link: '/en/media/mediatheque/freebox',
    description: 'Logos du Groupe et de ses filiales',
    imageUrl: '/assets/images/photo-library/iliad.png'
  },
  {
    title: 'Freebox',
    items: [],
    link: '/en/media/mediatheque/freebox',
    description: 'Photos des différentes box et des interfaces TV correspondantes',
    imageUrl: '/assets/images/photo-library/iliad.png'
  },
  {
    title: 'Free Centers',
    items: [],
    link: '/fr/media/mediatheque/boutiques',
    description: 'Photos des boutiques Free',
    imageUrl: '/assets/images/photo-library/iliad.png'
  }
]

let localizedMenu = Map<string, List<IMenuItem>>()
localizedMenu = localizedMenu.set('fr', List(frItems))
localizedMenu = localizedMenu.set('en', List(enItems))

export const photoLibrary = localizedMenu
